module.exports = "/assets/data/d30af3e2704fad5689d7c77d9a8e9db5-ST6.data.json";